import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import axios from 'axios';
import { message } from 'antd';
import { getOrderDetail } from '../clientsReducers/orderGroupsReducer';

export const getFormFilters = createAsyncThunk(
  'deliveryMap/getFormFilters',
  async (data, { rejectWithValue }) => {
    const api = '/map/filterInfoForMap?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));
      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getDataForMap = createAsyncThunk(
  'deliveryMap/getDataForMap',
  async (data, { rejectWithValue }) => {
    const api = '/map/get?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        // Группировка кухонь по kitchenId
        const kitchensRaw = response.data.data.kitchens || [];
        // Проверяем, что kitchens это массив
        const kitchensArray = Array.isArray(kitchensRaw) ? kitchensRaw : [];
        const kitchensMap = new Map();
        kitchensArray.forEach(kitchen => {
          if (!kitchensMap.has(kitchen.kitchenId)) {
            kitchensMap.set(kitchen.kitchenId, []);
          }
          kitchensMap.get(kitchen.kitchenId).push(kitchen);
        });
        const kitchens = Array.from(kitchensMap.values()).map(group => {
          const [first] = group;
          return {
            ...first,
            polygons: group.map(k => ({
              polygonId: k.polygonId,
              polygonName: k.polygonName,
              raceId: k.raceId,
              racePolygonId: k.racePolygonId,
              shutdownTime: k.shutdownTime,
              timeEnd: k.timeEnd,
              timeStart: k.timeStart,
              timeTransferringOrderToCourier: k.timeTransferringOrderToCourier,
              timezone: k.timezone,
            })),
          };
        });

        return {
          serverTime: response.data.data.serverTime,
          timezone: response.data.data.timezone,
          startDeliveryTime: response.data.data.startDeliveryTime,
          endDeliveryTime: response.data.data.endDeliveryTime,

          locations: response.data.data.locations,
          emptyLocations: response.data.data.locationsAll,
          addresses: response.data.data.addresses,
          kitchens: kitchens,
          couriers: response.data.data.couriers,
          locationsTypeObjectCatalog: response.data.data.locationsTypeObject,
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);
  
export const getCheckData = createAsyncThunk(
  'deliveryMap/getCheckData',
  async (_, { getState, rejectWithValue }) => {
    const api = '/map/checkData?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      cityId: getState().deliveryMap.selectedFilters.city?.id,
      racePolygonIds: getState().deliveryMap.selectedFilters.polygons,
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const searchOrders = createAsyncThunk(
  'deliveryMap/searchOrders',
  async (searchQuery, { getState, dispatch, rejectWithValue }) => {
    const api = '/map/search?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      cityId: getState().deliveryMap.selectedFilters.city?.id,
      racePolygonIds: getState().deliveryMap.selectedFilters.polygons,
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      query: searchQuery,
    }

    if (!getState().deliveryMap.selectedFilters.date) {
      return message.error('Выберите дату доставки');
    }

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result && response.data.data.length === 0) {
        // Если серверный поиск не нашел результатов и поисковый запрос является числом, вызываем дополнительный поиск
        const isNumeric = !isNaN(searchQuery) && !isNaN(parseFloat(searchQuery));
        if (isNumeric) {
          const deepSearchAction = await dispatch(getOrderDetail({ orderId: searchQuery }));

          if (deepSearchAction.meta.requestStatus === 'fulfilled' && deepSearchAction.payload) {
            return {
              query: searchQuery,
              orders: [],
              deepOrder: deepSearchAction.payload || null, 
            };
          } else {
            return {
              query: searchQuery,
              orders: [],
              deepOrder: null,
            };
          }
        } else {
          return {
              query: searchQuery,
              orders: [],
              deepOrder: null, 
            };
        }
      } else if (response.data.result) {
        return {
          query: searchQuery,
          orders: response.data.data,
          deepOrder: null, // Сбрасываем deepOrder если основной поиск успешен
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getDetailLocation = createAsyncThunk(
  'deliveryMap/getDetailLocation',
  async (id, { getState, rejectWithValue }) => {
    const api = '/map/getDetailsLocation?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      cityId: getState().deliveryMap.selectedFilters.city?.id,
      racePolygonIds: getState().deliveryMap.selectedFilters.polygons,
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      locationId: id,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const fetchGeocode = createAsyncThunk(
  'deliveryMap/fetchGeocode',
  async (data, { getState, rejectWithValue }) => {
    const reversCoords = [data[1], data[0]]
    try {
      const response = await axios.get('https://geocode-maps.yandex.ru/1.x/', {
        params: {
          apikey: '32a35624-b004-474d-b343-426da5feddae',
          geocode: reversCoords.join(','),
          format: 'json',
          kind: 'house',
          results: 1,
        },
      });

      const geoObjectCollection = response.data.response.GeoObjectCollection;

      if (geoObjectCollection.featureMember.length > 0) {
        const citiesLib = getState().settingsCatalogs.cities;
        const geoObject = geoObjectCollection.featureMember[0].GeoObject;
        const coords = geoObject?.Point?.pos?.split(' ').map(Number).reverse();
        const address = geoObject.metaDataProperty.GeocoderMetaData.Address;
        const addressFormatted = address.formatted;
        const addressDetails = geoObject.metaDataProperty.GeocoderMetaData.AddressDetails;
        const components = address?.Components || [];

        const getComponent = (kind) => {
          const filteredComponents = components.filter(component => component.kind === kind);
          return filteredComponents.length > 0 ? filteredComponents[filteredComponents.length - 1].name : null;
        };

        const findKeyInObject = (obj, key) => {
          if (obj === null || typeof obj !== 'object') {
            return undefined;
          }
          if (obj.hasOwnProperty(key)) {
            return obj[key];
          }
          for (const k in obj) {
            if (obj.hasOwnProperty(k)) {
              const result = findKeyInObject(obj[k], key);
              if (result !== undefined) {
                return result;
              }
            }
          }
          return undefined;
        };

        const country = getComponent('country') || '';
        const administrativeArea = getComponent('province') || '';
        const city = getComponent('locality') || getComponent('area') || '';
        const street = getComponent('street') || '';
        const house = getComponent('house') || '';
        const postalCodeNumber = findKeyInObject(addressDetails, 'PostalCodeNumber') || '';

        return {
          formatted: addressFormatted,
          coords: coords,
          country: country,
          administrativeArea: administrativeArea,
          cityId: citiesLib.find(item => item.name.toLowerCase() === city.toLowerCase())?.id,
          city: city,
          street: street,
          house: house,
          postalCodeNumber: postalCodeNumber,
          isCorrectGeocode: true,
        };
      } else {
        // Если featureMember пустой, но есть координаты в metaDataProperty
        const metaData = geoObjectCollection.metaDataProperty?.GeocoderResponseMetaData;
        if (metaData?.Point?.pos) {
          const coords = metaData.Point.pos.split(' ').map(Number).reverse();
          return {
            formatted: '',
            coords: coords,
            country: '',
            administrativeArea: '',
            cityId: null,
            city: '',
            street: '',
            house: '',
            postalCodeNumber: '',
            isCorrectGeocode: false,
          };
        }
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createLocation = createAsyncThunk(
  'deliveryMap/createLocation',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          id: response.data.data.location.id,
          longitude: data.longitude,
          latitude: data.latitude,
          countOrders: 0,
          chiefCourierId: null,
          couriers: [],
          locationName: data.name,
          locationStreet: data.street,
          locationHouse: data.house,
          locationTypeObjectId: data.locationTypeObjectId,
          deliveryStatus: 1,
          addressesIds: []
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateLocation = createAsyncThunk(
  'deliveryMap/updateLocation',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deleteLocation = createAsyncThunk(
  'deliveryMap/deleteLocation',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateLocationCoords = createAsyncThunk(
  'deliveryMap/updateLocationCoords',
  async ({ latitude, longitude }, { getState, rejectWithValue }) => {
    const api = '/delivery/locations/update?XDEBUG_SESSION_START=MyVSCode';
    const detailLocation = getState().deliveryMap.detailLocation;

    const data = {
      locationId: getState().deliveryMap.currentLocationId,
      ...detailLocation.location,
      name: detailLocation.location.locationName,
      serviceFeeEnabled: detailLocation.location.locationServiceFeeEnabled,
      latitude,
      longitude,
    }

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addAddressToLocation = createAsyncThunk(
  'deliveryMap/addAddressToLocation',
  async ({locationId, addressIds}, { getState, rejectWithValue }) => { console.log('addAddressToLocation called with:', {locationId, addressIds});
    const api = '/delivery/locations/addresses/create?XDEBUG_SESSION_START=MyVSCode';
    const currentLocationId = getState().deliveryMap.currentLocationId;
    const locations = getState().deliveryMap.locations;
    const currentLocationCouriers = locations.find(location => location.id === currentLocationId)?.couriers[0] || 0;
    
    const data = {
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      locationId: locationId || getState().deliveryMap.currentLocationId,
      courierId: currentLocationCouriers,
      addressIds: addressIds,
    }

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeAddressFromLocation = createAsyncThunk(
  'deliveryMap/removeAddressFromLocation',
  async ({ dataTransferObject, emptyAddress }, { rejectWithValue }) => {
    const api = '/delivery/locations/addresses/delete?XDEBUG_SESSION_START=MyVSCode';
    const data = {locationAddressIds: [dataTransferObject.locationAddressId]};

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return { dataTransferObject, emptyAddress };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createLocationMeetpoint = createAsyncThunk(
  'deliveryMap/createLocationMeetpoint',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/meetingPoints/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deleteLocationMeetpoint = createAsyncThunk(
  'deliveryMap/deleteLocationMeetpoint',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/meetingPoints/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addAddressToMeetpoint = createAsyncThunk(
  'deliveryMap/addAddressToMeetpoint',
  async (dto, { rejectWithValue }) => {
    const api = '/delivery/locations/meetingPoints/addresses/create?XDEBUG_SESSION_START=MyVSCode';
    const updateApi = '/delivery/locations/meetingPoints/addresses/update?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      locationsMeetingPointsAddressesId: dto?.locationsMeetingPointsAddressesId,
      addressId: dto.addressId,
      meetingPointId: dto.meetingPointId,
    }

    try {
      const response = await apiInstance.post(dto.update ? updateApi : api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeAddressFromMeetpoint = createAsyncThunk(
  'deliveryMap/removeAddressFromMeetpoint',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/meetingPoints/addresses/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createLocationEntrance = createAsyncThunk(
  'deliveryMap/createLocationEntrance',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/entrance/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deleteLocationEntrance = createAsyncThunk(
  'deliveryMap/deleteLocationEntrance',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/entrance/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addAddressToEntrance = createAsyncThunk(
  'deliveryMap/addAddressToEntrance',
  async (dto, { rejectWithValue }) => {
    const api = '/delivery/locations/entrance/addresses/create?XDEBUG_SESSION_START=MyVSCode';
    const updateApi = '/delivery/locations/entrance/addresses/update?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      locationEntranceAddressId: dto?.locationEntranceAddressId,
      addressId: dto.addressId,
      locationEntranceId: dto.locationEntranceId,
    }

    try {
      const response = await apiInstance.post(dto.update ? updateApi : api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeAddressFromEntrance = createAsyncThunk(
  'deliveryMap/removeAddressFromEntrance',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/locations/entrance/addresses/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateAddressCashbackPercent = createAsyncThunk(
  'deliveryMap/updateAddressCashbackPercent',
  async (data, { rejectWithValue }) => {
    const api = '/address/updateCashbackPercent?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateAddressComment = createAsyncThunk(
  'deliveryMap/updateAddressComment',
  async (data, { rejectWithValue }) => {
    const api = '/address/updateComment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateOrderComment = createAsyncThunk(
  'deliveryMap/updateOrderComment',
  async (data, { rejectWithValue }) => {
    const api = '/order/updateComment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const assignCourierToLocations = createAsyncThunk(
  'deliveryMap/assignCourierToLocations',
  async ({ courierId, locationIds }, { getState, dispatch, rejectWithValue }) => {
    const api = '/courier/assignToLocations?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      courierId: courierId,
      locationIds: locationIds,
      day: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        dispatch(getCheckData());
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const assignCourierToOrder = createAsyncThunk(
  'deliveryMap/assignCourierToOrder',
  async (data, { rejectWithValue }) => {
    const api = '/courier/assignToOrder?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addCourierToKitchen = createAsyncThunk(
  'deliveryMap/addCourierToKitchen',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/kitchen/addCourier?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          ...data,
          assignmentId: response.data.data.kitchenCourierAssignmentId,
        }
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeCourierFromKitchen = createAsyncThunk(
  'deliveryMap/removeCourierFromKitchen',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/kitchen/deleteCourier?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getDetailKitchen = createAsyncThunk(
  'deliveryMap/getDetailKitchen',
  async (id, { getState, rejectWithValue }) => {
    const api = '/map/getDetailsKitchen?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      cityId: getState().deliveryMap.selectedFilters.city?.id,
      racePolygonIds: getState().deliveryMap.selectedFilters.polygons,
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      kitchenId: id,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getCourierDetails = createAsyncThunk(
  'deliveryMap/getCourierDetails',
  async (id, { getState, rejectWithValue }) => {
    const api = '/map/getCourierDetails?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      courierId: id,
    }

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.locations;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getCouriersTrack = createAsyncThunk(
  'deliveryMap/getCouriersTrack',
  async (data, { rejectWithValue }) => {
    const api = '/map/getWhereCouriers?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.trackCouriers;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const changeCourierKMpassed = createAsyncThunk(
  'deliveryMap/changeCourierKMpassed',
  async ({raceId, deliveryDay, courierId, km}, { getState, rejectWithValue }) => {
    const api = '/map/setKMbyRaceDeliveryDay?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      raceId,
      deliveryDay,
      courierId,
      km: km || 0,
    }

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getDetailAddress = createAsyncThunk(
  'deliveryMap/getDetailAddress',
  async (id, { getState, rejectWithValue }) => {
    const api = '/map/getDetailsAddress?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      cityId: getState().deliveryMap.selectedFilters.city?.id,
      racePolygonIds: getState().deliveryMap.selectedFilters.polygons,
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      addressId: id,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const compliteOrders = createAsyncThunk(
  'deliveryMap/compliteOrders',
  async (data, { rejectWithValue }) => {
    const api = '/delivery/deliveredByOrderIds?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

async function blobUrlToFile(blobUrl, fileName) {
    // 1. Загружаем blob-URL как Blob
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    
    // 2. Преобразуем Blob в File
    return new File([blob], fileName, { type: blob.type || 'image/jpeg' });
}

export const addLocationPhoto = createAsyncThunk(
  'deliveryMap/addLocationPhoto',
  async (data, { rejectWithValue }) => {
    const api = '/map/createPhotoLocation?XDEBUG_SESSION_START=MyVSCode';

    let formData = new FormData();

    // Если data.image - это blob-URL (строка)
    if (typeof data.image === 'string' && data.image.startsWith('blob:')) {
        try {
            const file = await blobUrlToFile(data.image, 'product-image.jpg');
            formData.append('image', file);
            // Удаляем data.image, чтобы не отправлять пустой объект
            delete data.image;
        } catch (error) {
            return rejectWithValue('Failed to convert blob URL to file');
        }
    } else if (data.image instanceof Blob) {
        // Если это Blob/File
        formData.append('image', data.image);
        // Удаляем data.image, чтобы не отправлять пустой объект
        delete data.image;
    }

    formData.append('data', JSON.stringify(data));

    try {
      const response = await apiInstance.post(api, formData);

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeLocationPhoto = createAsyncThunk(
  'deliveryMap/deletePhotoLocation',
  async (data, { rejectWithValue }) => {
    const api = '/map/deletePhotoKitchen?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addKitchenPhoto = createAsyncThunk(
  'deliveryMap/addKitchenPhoto',
  async (data, { rejectWithValue }) => {
    const api = '/map/createPhotoKitchen?XDEBUG_SESSION_START=MyVSCode';

    let formData = new FormData();

    // Если data.image - это blob-URL (строка)
    if (typeof data.image === 'string' && data.image.startsWith('blob:')) {
        try {
            const file = await blobUrlToFile(data.image, 'product-image.jpg');
            formData.append('image', file);
            // Удаляем data.image, чтобы не отправлять пустой объект
            delete data.image;
        } catch (error) {
            return rejectWithValue('Failed to convert blob URL to file');
        }
    } else if (data.image instanceof Blob) {
        // Если это Blob/File
        formData.append('image', data.image);
        // Удаляем data.image, чтобы не отправлять пустой объект
        delete data.image;
    }

    formData.append('data', JSON.stringify(data));

    try {
      const response = await apiInstance.post(api, formData);

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const removeKitchenPhoto = createAsyncThunk(
  'deliveryMap/removeKitchenPhoto',
  async (data, { rejectWithValue }) => {
    const api = '/map/deletePhotoKitchen?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const courierRouteSave = createAsyncThunk(
  'deliveryMap/courierRouteSave',
  async (newRoutes, { getState, rejectWithValue }) => {
    const api = '/map/courierRouteSave?XDEBUG_SESSION_START=MyVSCode';
    const data = {
      deliveryDay: getState().deliveryMap.selectedFilters.date,
      raceId: getState().deliveryMap.selectedFilters.timePeriod,
      courierId: getState().deliveryMap.currentCourierId,
      routes: newRoutes,
    };

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

// Селекторы для фильтрации
export const selectFilteredLocations = (state) => {
  const {
    locations,
    searchOrdersQuery,
    foundOrders,
    locationFilters,
  } = state.deliveryMap;

  let filteredLocations = Array.isArray(locations) ? locations : [];

  const predicates = [];
  const hasAssignedCourier = (location) => (
    Boolean(location?.chiefCourierId) ||
    (Array.isArray(location?.couriers) && location.couriers.length > 0)
  );

  // Поиск: это тоже предикат (для одинакового принципа)
  if (searchOrdersQuery) {
    predicates.push((location) =>
      location.addressesIds?.some((addressId) => foundOrders.includes(addressId))
    );
  }

  // Фильтры: AND между включёнными условиями
  if (locationFilters) {
    const assigned = Boolean(locationFilters.assigned);
    const notAssigned = Boolean(locationFilters.notAssigned);
    const firstTimers = Boolean(locationFilters.firstTimers);

    // Группа назначений: assigned OR notAssigned
    // - включён только один -> добавляем предикат
    // - включены оба -> ничего не добавляем (значит показываем все по назначению)
    if (assigned !== notAssigned) {
      predicates.push((location) => {
        const hasAssigned = hasAssignedCourier(location);
        return assigned ? hasAssigned : !hasAssigned;
      });
    }

    if (firstTimers) {
      predicates.push((location) => Boolean(location?.hasFirstTimers));
    }
  }

  for (const predicate of predicates) {
    filteredLocations = filteredLocations.filter(predicate);
  }
  
  // Фильтрация по выбранным кухням
  // if (selectedFilterKitchens.length > 0) {
  //   filteredLocations = filteredLocations.map(location => {
  //     // Фильтруем адреса внутри локации
  //     const filteredAddresses = Object.fromEntries(
  //       Object.entries(location.addresses).filter(([_, point]) => {
  //         return point.orders.some(order => 
  //           selectedFilterKitchens.some(k => k.id === order.kitchen?.id)
  //         );
  //       })
  //     );
      
  //     // Возвращаем локацию только если остались адреса после фильтрации
  //     return filteredAddresses && Object.keys(filteredAddresses).length > 0
  //       ? { ...location, addresses: filteredAddresses }
  //       : null;
  //   }).filter(Boolean); // Удаляем null (пустые локации)
  // }
  
  return filteredLocations;
};

export const selectFilteredAddresses = (state) => {
  const { addresses, searchOrdersQuery, foundOrders } = state.deliveryMap;

  let filteredAddresses = addresses;

  // Фильтрация по поисковому запросу
  if (searchOrdersQuery) {
    filteredAddresses = filteredAddresses.filter(address =>
      foundOrders.includes(address.id)
    );
  }
  
  // Фильтрация по выбранным кухням
  // if (selectedFilterKitchens.length > 0) {
  //   filteredPoints = filteredPoints.filter(point => 
  //     point.orders.some(order => 
  //       selectedFilterKitchens.some(k => k.id === order.kitchen?.id)
  //     )
  //   );
  // }

  return filteredAddresses;
};

export const selectFilteredKitchens = (state) => {
  const { kitchens, searchKitchenQuery } = state.deliveryMap;
  if (!searchKitchenQuery) return kitchens;

  return kitchens.filter(kitchen =>
      kitchen.kitchenId?.toString().toLowerCase().includes(searchKitchenQuery.toLowerCase()) ||
      kitchen.kitchenName?.toString().toLowerCase().includes(searchKitchenQuery.toLowerCase())
  );
};

const initialState = {
  //Statuses
  getFormFiltersStatus: null,
  getDataForMapStatus: null,
  getCheckDataStatus: null,
  searchOrdersStatus: null,
  getDetailLocationStatus: null,
  fetchGeocodeStatus: null,
  createLocationStatus: null,
  updateLocationStatus: null,
  deleteLocationStatus: null,
  updateLocationCoordsStatus: null,
  addAddressToLocationStatus: null,
  removeAddressFromLocationStatus: null,
  createLocationMeetpointStatus: null,
  deleteLocationMeetpointStatus: null,
  addAddressToMeetpointStatus: null,
  removeAddressFromMeetpointStatus: null,
  createLocationEntranceStatus: null,
  deleteLocationEntranceStatus: null,
  addAddressToEntranceStatus: null,
  removeAddressFromEntranceStatus: null,
  updateAddressCashbackPercentStatus: null,
  updateAddressCommentStatus: null,
  updateOrderCommentStatus: null,
  assignCourierToLocationsStatus: null,
  assignCourierToOrderStatus: null,
  addCourierToKitchenStatus: null,
  removeCourierFromKitchenStatus: null,
  getDetailKitchenStatus: null,
  getCourierDetailsStatus: null,
  getCouriersTrackStatus: null,
  changeCourierKMpassedStatus: null,
  getDetailAddressStatus: null,
  addLocationPhotoStatus: null,
  removeLocationPhotoStatus: null,
  addKitchenPhotoStatus: null,
  removeKitchenPhotoStatus: null,

  //Form Filters
  formFilters: [],
  selectedFilters: {
    city: null,
    cityCoordinates: [53.5303, 49.3461],
    delivery: null,
    timePeriod: null,
    date: null,
    polygons: null,
  },

  //checkData
  checkData: null,

  //Visibility
  mapDataVisibility: JSON.parse(localStorage.getItem('mapDataVisibility')) || {
    emptyLocations: false,
    locations: true,
    onlyHeldPaymentsLocations: false,
    kitchens: false,
    addresses: true,
    polygons: false,
    couriers: false,
    courierFlights: false,
  },

  //Modes
  mapMode: 'defaultMode', // createLocation | relocateMode | createEntranceMode | assignCourierMode | addAddressToLocationMode | changeCourierRouteMode | defaultMode
  refresh: false,
  autoRefresh: false,
  isSoundEnabled: true,
  shouldPlaySound: false,

  //Search
  searchOrdersQuery: '',
  foundOrders: [],
  deepFoundOrder: null,

  //Location filters
  locationFilters: {
    assigned: false,
    notAssigned: false,
    firstTimers: false,
  },

  //Catalogs
  locationsTypeObjectCatalog: [],
  serverTime: null,
  timezone: null,
  startDeliveryTime: null,
  endDeliveryTime: null,

  //Locations
  locationsShow: false,
  emptyLocations: [],
  locations: [],
  currentLocationId: null,
  detailLocation: null,
  geocodeAddress: null,

  //Addresses
  addressesShow: false,
  addresses: [],
  currentAddressId: null,
  detailAddress: null,

  //Kitchens
  kitchensShow: false,
  kitchens: [],
  currentKitchenId: null,
  detailKitchen: null,

  //Couriers
  couriersShow: false,
  couriers: [],
  currentCourierId: null,
  courierDetails: null,
  couriersTrack: [],
  visibleCouriersTrack: [],

  polygons: [],
};

const deliveryMapSlice = createSlice({
  name: 'deliveryMap',
  initialState,
  extraReducers: (builder) => {
    builder
      //Form Filters
      .addCase(getFormFilters.pending, (state) => { state.getFormFiltersStatus = 'pending'; })
      .addCase(getFormFilters.fulfilled, (state, action) => {
        state.getFormFiltersStatus = 'fulfilled';
        const cities = action.payload?.cities || [];
        state.formFilters = cities;

        // Синхронизируем selectedFilters с новыми formFilters
        const currentCityId = state.selectedFilters.city?.id;

        if (currentCityId) {
          // Пытаемся найти обновлённый объект города в новых cities
          const updatedCity = cities.find(c => c.id === currentCityId);

          if (updatedCity) {
            // Заменяем объект city, чтобы получить обновлённые deliveryServices, timezone и т.д.
            state.selectedFilters.city = updatedCity;
            // Обновляем координаты, если доступны
            state.selectedFilters.cityCoordinates = [updatedCity.cityLatitude, updatedCity.cityLongitude];

            // Проверяем, существует ли текущая выбранная служба доставки
            const currentDeliveryId = state.selectedFilters.delivery?.id;
            if (currentDeliveryId) {
              const updatedDelivery = updatedCity.deliveryServices?.find(d => d.id === currentDeliveryId);
              if (!updatedDelivery) {
                // Сбрасываем delivery/timePeriod/date/polygons, если служба доставки удалена
                state.selectedFilters.delivery = null;
                state.selectedFilters.timePeriod = null;
                state.selectedFilters.date = null;
                state.selectedFilters.polygons = null;
              } else {
                // Обновляем ссылку на объект delivery
                state.selectedFilters.delivery = updatedDelivery;

                // Проверяем, что выбранный период (timePeriod) всё ещё есть в обновлённой доставке
                const currentTimePeriod = state.selectedFilters.timePeriod;
                if (currentTimePeriod) {
                  const existsPeriod = updatedDelivery.listPeriods?.some(p => p.raceId === currentTimePeriod);
                  if (!existsPeriod) {
                    state.selectedFilters.timePeriod = null;
                    state.selectedFilters.date = null;
                    state.selectedFilters.polygons = null;
                  }
                }
              }
            }
          } else {
            // Выбранный город больше не существует — очищаем зависимые фильтры
            state.selectedFilters.city = null;
            state.selectedFilters.cityCoordinates = [53.5303, 49.3461];
            state.selectedFilters.delivery = null;
            state.selectedFilters.timePeriod = null;
            state.selectedFilters.date = null;
            state.selectedFilters.polygons = null;
          }
        } else {
          // Город не выбран — нечего синхронизировать
        }
      })
      .addCase(getFormFilters.rejected, (state) => { state.getFormFiltersStatus = 'rejected'; })

      //Data For Map
      .addCase(getDataForMap.pending, (state) => {
        state.getDataForMapStatus = 'pending';
        state.searchOrdersQuery = '';
        state.foundOrders = [];
        state.deepFoundOrder = null;
      })
      .addCase(getDataForMap.fulfilled, (state, action) => { console.log('getDataForMap.fulfilled action.payload:', action.payload);
        state.getDataForMapStatus = 'fulfilled';
        state.serverTime = action.payload.serverTime;
        state.timezone = action.payload.timezone;
        state.startDeliveryTime = action.payload.startDeliveryTime;
        state.endDeliveryTime = action.payload.endDeliveryTime;

        // Проверяем условия для воспроизведения звука
        const shouldCheckSound = state.isSoundEnabled;
        
        if (shouldCheckSound) {
          const currentLocations = state.locations || [];
          const currentAddresses = state.addresses || [];
          const newLocations = action.payload.locations || [];
          const newAddresses = action.payload.addresses || [];
          
          // Сравниваем длины массивов
          const hasNewLocations = newLocations.length > currentLocations.length;
          const hasNewAddresses = newAddresses.length > currentAddresses.length;
          
          if (hasNewLocations || hasNewAddresses) {
            console.log('getDataForMap: Обнаружены новые точки доставки', {
              locations: { old: currentLocations.length, new: newLocations.length, diff: newLocations.length - currentLocations.length },
              addresses: { old: currentAddresses.length, new: newAddresses.length, diff: newAddresses.length - currentAddresses.length }
            });
            state.shouldPlaySound = true;
          }
        }

        state.locations = action.payload.locations;
        state.emptyLocations = action.payload.emptyLocations;
        state.addresses = action.payload.addresses;
        state.kitchens = action.payload.kitchens;
        state.couriers = action.payload.couriers;
        state.locationsTypeObjectCatalog = action.payload.locationsTypeObjectCatalog;
      })
      .addCase(getDataForMap.rejected, (state) => { console.log('getDataForMap.rejected'); state.getDataForMapStatus = 'rejected'; })

      //getCheckData
      .addCase(getCheckData.pending, (state) => { state.getCheckDataStatus = 'pending'; })
      .addCase(getCheckData.fulfilled, (state, action) => { state.getCheckDataStatus = 'fulfilled'; state.checkData = action.payload; })
      .addCase(getCheckData.rejected, (state) => { state.getCheckDataStatus = 'rejected'; })

      //searchOrders
      .addCase(searchOrders.pending, (state) => { state.searchOrdersStatus = 'pending'; })
      .addCase(searchOrders.fulfilled, (state, action) => {
        state.searchOrdersStatus = 'fulfilled';
        state.searchOrdersQuery = action.payload.query;
        state.foundOrders = action.payload.orders;
        state.deepFoundOrder = action.payload.deepOrder;
      })
      .addCase(searchOrders.rejected, (state) => { state.searchOrdersStatus = 'rejected'; })

      //getDetailLocation
      .addCase(getDetailLocation.pending, (state) => { state.getDetailLocationStatus = 'pending'; })
      .addCase(getDetailLocation.fulfilled, (state, action) => { state.getDetailLocationStatus = 'fulfilled'; state.detailLocation = action.payload; })
      .addCase(getDetailLocation.rejected, (state) => { state.getDetailLocationStatus = 'rejected'; })

      //fetchGeocode
      .addCase(fetchGeocode.pending, (state) => { state.fetchGeocodeStatus = 'pending'; })
      .addCase(fetchGeocode.fulfilled, (state, action) => { state.fetchGeocodeStatus = 'fulfilled'; state.geocodeAddress = action.payload; })
      .addCase(fetchGeocode.rejected, (state) => { state.fetchGeocodeStatus = 'rejected'; })

      //createLocation
      .addCase(createLocation.pending, (state) => { state.createLocationStatus = 'pending'; })
      .addCase(createLocation.fulfilled, (state, action) => { state.createLocationStatus = 'fulfilled'; state.emptyLocations = [...state.emptyLocations, action.payload]; state.mapMode = 'defaultMode'; })
      .addCase(createLocation.rejected, (state) => { state.createLocationStatus = 'rejected'; })

      //updateLocation
      .addCase(updateLocation.pending, (state) => { state.updateLocationStatus = 'pending'; })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.updateLocationStatus = 'fulfilled';
        const updatedLocation = action.payload;
        state.locations = state.locations.map(location =>
          location.id === updatedLocation.locationId ? { ...location, 
            locationName: updatedLocation.name,
            name: updatedLocation.name,
            locationStreet: updatedLocation.street,
            locationHouse: updatedLocation.house,
            locationTypeObjectId: updatedLocation.locationTypeObjectId,
            latitude: updatedLocation.latitude,
            longitude: updatedLocation.longitude,
          } : location
        );
        state.emptyLocations = state.emptyLocations.map(location =>
          location.id === updatedLocation.locationId ? { ...location, 
            locationName: updatedLocation.name,
            name: updatedLocation.name,
            locationStreet: updatedLocation.street,
            locationHouse: updatedLocation.house,
            locationTypeObjectId: updatedLocation.locationTypeObjectId,
            latitude: updatedLocation.latitude,
            longitude: updatedLocation.longitude,
          } : location
        );
      })
      .addCase(updateLocation.rejected, (state) => { state.updateLocationStatus = 'rejected'; })

      //deleteLocation
      .addCase(deleteLocation.pending, (state) => { state.deleteLocationStatus = 'pending'; })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.deleteLocationStatus = 'fulfilled';
        const deletedLocationId = action.payload.id;
        state.locations = state.locations.filter(location => location.id !== deletedLocationId);
        if (state.currentLocationId === deletedLocationId) {
          state.currentLocationId = null; // Сброс текущей локации при удалении
        }
      })
      .addCase(deleteLocation.rejected, (state) => { state.deleteLocationStatus = 'rejected'; })

      //updateLocationCoords
      .addCase(updateLocationCoords.pending, (state) => { state.updateLocationCoordsStatus = 'pending'; })
      .addCase(updateLocationCoords.fulfilled, (state, action) => {
        state.updateLocationCoordsStatus = 'fulfilled';
        const updatedLocation = action.payload;
        console.log('Updated Location:', updatedLocation);
        state.locations = state.locations.map(location =>
          location.id === updatedLocation.locationId ? { ...location, latitude: updatedLocation.latitude, longitude: updatedLocation.longitude } : location
        );
        state.emptyLocations = state.emptyLocations.map(location =>
          location.id === updatedLocation.locationId ? { ...location, latitude: updatedLocation.latitude, longitude: updatedLocation.longitude } : location
        );
        state.mapMode = 'defaultMode';
      })
      .addCase(updateLocationCoords.rejected, (state) => { state.updateLocationCoordsStatus = 'rejected'; })

      // addAddressToLocation
      .addCase(addAddressToLocation.pending, (state) => { state.addAddressToLocationStatus = 'pending'; })
      .addCase(addAddressToLocation.fulfilled, (state, action) => {
        state.addAddressToLocationStatus = 'fulfilled';
        const { locationId, addressIds } = action.payload; 

        // Ищем локацию в locations
        const locationInLocations = state.locations.find(location => location.id === locationId);
        
        if (locationInLocations) {
          // Обновляем locations - добавляем addressIds в нужную локацию
          state.locations = state.locations.map(location => {
            if (location.id === locationId) {
              return {
                ...location,
                addressesIds: [...(location.addressesIds || []), ...addressIds],
                countOrders: (location.countOrders || 0) + addressIds.length,
              };
            }
            return location;
          });
        } else {
          // Ищем локацию в emptyLocations
          const locationInEmptyLocations = state.emptyLocations.find(location => location.id === locationId);
          
          if (locationInEmptyLocations) {
            // Обновляем локацию с новыми addressIds
            const updatedLocation = {
              ...locationInEmptyLocations,
              addressesIds: [...(locationInEmptyLocations.addressesIds || []), ...addressIds],
              countOrders: (locationInEmptyLocations.countOrders || 0) + addressIds.length,
            };
            
            // Перемещаем локацию из emptyLocations в locations
            state.locations = [...state.locations, updatedLocation];
            state.emptyLocations = state.emptyLocations.filter(location => location.id !== locationId);
          }
        }

        // Убираем адресс из активных адресов 
        state.currentAddressId = null;
        // Удаляем добавленные адреса из списка доступных адресов
        state.addresses = state.addresses.filter(address => !addressIds.includes(address.id));
      })
      .addCase(addAddressToLocation.rejected, (state) => { state.addAddressToLocationStatus = 'rejected'; })

      // removeAddressFromLocation
      .addCase(removeAddressFromLocation.pending, (state) => { state.removeAddressFromLocationStatus = 'pending'; })
      .addCase(removeAddressFromLocation.fulfilled, (state, action) => {
        state.removeAddressFromLocationStatus = 'fulfilled';
        const { dataTransferObject, emptyAddress } = action.payload;
        const locationAddressId = dataTransferObject.locationAddressId;

        if (emptyAddress) {
          state.detailLocation.addresses = state.detailLocation.addresses.filter(order => order.locationAddressId !== locationAddressId);
        } else {
          // Удаляем order по locationAddressId
          if (state.detailLocation && Array.isArray(state.detailLocation.orders)) {
            state.detailLocation.orders = state.detailLocation.orders.filter(order => order.locationAddressId !== locationAddressId);
          }
          // Добавляем адрес в state.addresses
          state.addresses = [...state.addresses, dataTransferObject];
          
          // Проверяем, остались ли заказы в локации
          const remainingOrders = state.detailLocation.orders?.filter(order => order.locationAddressId !== locationAddressId) || [];

          console.log('Remaining Orders:', remainingOrders);
          // Если не осталось заказов и адресов, перемещаем локацию в emptyLocations
          if (remainingOrders.length === 0) {
            const locationId = state.detailLocation.location?.locationId;
            console.log('Location ID to move:', locationId);
            if (locationId) {
              // Находим локацию в locations
              const locationToMove = state.locations.find(location => location.id === locationId);
              console.log('Location to move:', locationToMove);
              if (locationToMove) {
                // Очищаем addressesIds у локации
                const emptyLocation = {
                  ...locationToMove,
                  addressesIds: []
                };
                
                // Перемещаем локацию из locations в emptyLocations
                state.emptyLocations = [...state.emptyLocations, emptyLocation];
                state.locations = state.locations.filter(location => location.id !== locationId);
              }
            }
          }
        }
      })
      .addCase(removeAddressFromLocation.rejected, (state) => { state.removeAddressFromLocationStatus = 'rejected'; })

      // createLocationMeetpoint
      .addCase(createLocationMeetpoint.pending, (state) => { state.createLocationMeetpointStatus = 'pending'; })
      .addCase(createLocationMeetpoint.fulfilled, (state, action) => {
        state.createLocationMeetpointStatus = 'fulfilled';
        const newMeetpoint = action.payload;
        const location = state.locations.find(loc => loc.id === newMeetpoint.locationId) || state.emptyLocations.find(loc => loc.id === newMeetpoint.locationId);
        if (location) {
          location.meetingPoints = [...(location.meetingPoints || []), newMeetpoint];
        }
      })
      .addCase(createLocationMeetpoint.rejected, (state) => { state.createLocationMeetpointStatus = 'rejected'; })

      // deleteLocationMeetpoint
      .addCase(deleteLocationMeetpoint.pending, (state) => { state.deleteLocationMeetpointStatus = 'pending'; })
      .addCase(deleteLocationMeetpoint.fulfilled, (state, action) => {
        state.deleteLocationMeetpointStatus = 'fulfilled';
        const deletedMeetpointId = action.payload.id;
        state.locations = state.locations.map(location => {
          if (location.meetingPoints) {
            location.meetingPoints = location.meetingPoints.filter(meetpoint => meetpoint.id !== deletedMeetpointId);
          }
          return location;
        });
      })
      .addCase(deleteLocationMeetpoint.rejected, (state) => { state.deleteLocationMeetpointStatus = 'rejected'; })

      // addAddressToMeetpoint
      .addCase(addAddressToMeetpoint.pending, (state) => { state.addAddressToMeetpointStatus = 'pending'; })
      .addCase(addAddressToMeetpoint.fulfilled, (state) => {
        state.addAddressToMeetpointStatus = 'fulfilled';
        state.locations = state.locations.map(location => location);
      })
      .addCase(addAddressToMeetpoint.rejected, (state) => { state.addAddressToMeetpointStatus = 'rejected'; })

      // removeAddressFromMeetpoint
      .addCase(removeAddressFromMeetpoint.pending, (state) => { state.removeAddressFromMeetpointStatus = 'pending'; })
      .addCase(removeAddressFromMeetpoint.fulfilled, (state) => {
        state.removeAddressFromMeetpointStatus = 'fulfilled';
        state.locations = state.locations.map(location => location);
      })
      .addCase(removeAddressFromMeetpoint.rejected, (state) => { state.removeAddressFromMeetpointStatus = 'rejected'; })

      // createLocationEntrance
      .addCase(createLocationEntrance.pending, (state) => { state.createLocationEntranceStatus = 'pending'; })
      .addCase(createLocationEntrance.fulfilled, (state, action) => {
        state.createLocationEntranceStatus = 'fulfilled';
        const newEntrance = action.payload;
        const location = state.locations.find(loc => loc.id === newEntrance.locationId) || state.emptyLocations.find(loc => loc.id === newEntrance.locationId);
        if (location) {
          location.entrances = [...(location.entrances || []), newEntrance];
        }
        state.mapMode = 'defaultMode';
      })
      .addCase(createLocationEntrance.rejected, (state) => { state.createLocationEntranceStatus = 'rejected'; })
      
      // deleteLocationEntrance
      .addCase(deleteLocationEntrance.pending, (state) => { state.deleteLocationEntranceStatus = 'pending'; })
      .addCase(deleteLocationEntrance.fulfilled, (state, action) => {
        state.deleteLocationEntranceStatus = 'fulfilled';
        const deletedEntranceId = action.payload.id;
        state.locations = state.locations.map(location => {
          if (location.entrances) {
            location.entrances = location.entrances.filter(entrance => entrance.id !== deletedEntranceId);
          }
          return location;
        });
      })
      .addCase(deleteLocationEntrance.rejected, (state) => { state.deleteLocationEntranceStatus = 'rejected'; })
      
      // addAddressToEntrance
      .addCase(addAddressToEntrance.pending, (state) => { state.addAddressToEntranceStatus = 'pending'; })
      .addCase(addAddressToEntrance.fulfilled, (state) => {
        state.addAddressToEntranceStatus = 'fulfilled'; 
        state.locations = state.locations.map(location => location);
      })
      .addCase(addAddressToEntrance.rejected, (state) => { state.addAddressToEntranceStatus = 'rejected'; })

      // removeAddressFromEntrance
      .addCase(removeAddressFromEntrance.pending, (state) => { state.removeAddressFromEntranceStatus = 'pending'; })
      .addCase(removeAddressFromEntrance.fulfilled, (state) => {
        state.removeAddressFromEntranceStatus = 'fulfilled';
        state.locations = state.locations.map(location => location);
      })
      .addCase(removeAddressFromEntrance.rejected, (state) => { state.removeAddressFromEntranceStatus = 'rejected'; })
      
      //updateAddressCashbackPercent
      .addCase(updateAddressCashbackPercent.pending, (state) => { state.updateAddressCashbackPercentStatus = 'pending'; })
      .addCase(updateAddressCashbackPercent.fulfilled, (state, action) => {
        state.updateAddressCashbackPercentStatus = 'fulfilled';
        const {addressId, cashbackPercent} = action.payload;
        if (state.detailLocation) {
          state.detailLocation = {
            ...state.detailLocation,
            orders: state.detailLocation.orders?.map(order =>
              order.addressId === addressId ? { ...order, addressCashbackPercent: cashbackPercent } : order
            ),
            addresses: state.detailLocation.addresses?.map(address => 
              address.addressId === addressId ? { ...address, addressCashbackPercent: cashbackPercent } : address
            )
          };
        }
      })
      .addCase(updateAddressCashbackPercent.rejected, (state) => { state.updateAddressCashbackPercentStatus = 'rejected'; })

      // updateAddressComment
      .addCase(updateAddressComment.pending, (state) => { state.updateAddressCommentStatus = 'pending'; })
      .addCase(updateAddressComment.fulfilled, (state, action) => {
        state.updateAddressCommentStatus = 'fulfilled';
        const {addressId, comment} = action.payload;
        if (state.detailLocation) {
          state.detailLocation = {
            ...state.detailLocation,
            orders: state.detailLocation.orders?.map(order =>
              order.addressId === addressId ? { ...order, addressComment: comment } : order
            )
          };
        }
      })
      .addCase(updateAddressComment.rejected, (state) => { state.updateAddressCommentStatus = 'rejected'; })

      // updateOrderComment
      .addCase(updateOrderComment.pending, (state) => { state.updateOrderCommentStatus = 'pending'; })
      .addCase(updateOrderComment.fulfilled, (state, action) => {
        state.updateOrderCommentStatus = 'fulfilled';
        const {orderId, comment} = action.payload;
        if (state.detailLocation) {
          state.detailLocation = {
            ...state.detailLocation,
            orders: state.detailLocation.orders?.map(order =>
              order.orderId === orderId ? { ...order, orderComment: comment } : order
            )
          };
        }
      })
      .addCase(updateOrderComment.rejected, (state) => { state.updateOrderCommentStatus = 'rejected'; })

      // assignCourierToLocations
      .addCase(assignCourierToLocations.pending, (state) => { state.assignCourierToLocationsStatus = 'pending'; })
      .addCase(assignCourierToLocations.fulfilled, (state, action) => {
        state.assignCourierToLocationsStatus = 'fulfilled';
        const { courierId, locationIds } = action.payload;
        
        // Обновляем локации
        state.emptyLocations = state.emptyLocations.map(location => {
          if (locationIds.includes(location.id)) {
              return { ...location, chiefCourierId: courierId };
          }
          return location;
        });

        // Обновляем локации
        state.locations = state.locations.map(location => {
          if (locationIds.includes(location.id)) {
              return { ...location, chiefCourierId: courierId, couriers: [courierId], courierMismatch: false };
          }
          return location;
        });

        // Обновляем информацию о курьере
        state.couriers = state.couriers.map(courier => {
          if (courier.courierId === courierId) {
            // Считаем количество локаций, где этот курьер является главным
            const countAddresses = state.locations.filter(location => location.chiefCourierId === courierId).length;
            return { ...courier, countAddresses: countAddresses };
          }
          return courier;
        });
      })
      .addCase(assignCourierToLocations.rejected, (state) => { state.assignCourierToLocationsStatus = 'rejected'; })

      // assignCourierToOrder
      .addCase(assignCourierToOrder.pending, (state) => { state.assignCourierToOrderStatus = 'pending'; })
      .addCase(assignCourierToOrder.fulfilled, (state, action) => {
        state.assignCourierToOrderStatus = 'fulfilled';
        const { locationId, orderId, courierId } = action.payload;
        if (state.detailLocation && state.detailLocation.orders) {
          // 1. Обновляем массив заказов
          const newOrders = state.detailLocation.orders.map(order =>
            order.orderId === orderId ? { ...order, courierId: courierId } : order
          );
          // 2. Получаем уникальные courierId
          const courierSet = Array.from(new Set(newOrders.map(order => order.courierId))).filter(id => id != null);
          // 3. Обновляем локацию
          state.locations = state.locations.map(location => {
            if (location.id === locationId) {
              return { ...location, couriers: courierSet };
            }
            return location;
          });
        }
      })
      .addCase(assignCourierToOrder.rejected, (state) => { state.assignCourierToOrderStatus = 'rejected'; })

      // addCourierToKitchen
      .addCase(addCourierToKitchen.pending, (state) => { state.addCourierToKitchenStatus = 'pending'; })
      .addCase(addCourierToKitchen.fulfilled, (state, action) => {
        state.addCourierToKitchenStatus = 'fulfilled';
        const { kitchenId, courierId, assignmentId } = action.payload;

        const kitchen = state.kitchens.find(k => k.kitchenId === kitchenId);
        if (kitchen) {
          kitchen.courierAssignment = [...(kitchen.courierAssignment || []), {
            courierId: courierId,
            assignmentId: assignmentId,
            name: state.couriers.find(c => c.courierId === courierId)?.name,
            prefix: state.couriers.find(c => c.courierId === courierId)?.prefix,
          }];
        }
      })
      .addCase(addCourierToKitchen.rejected, (state) => { state.addCourierToKitchenStatus = 'rejected'; })

      // removeCourierFromKitchen
      .addCase(removeCourierFromKitchen.pending, (state) => { state.removeCourierFromKitchenStatus = 'pending'; })
      .addCase(removeCourierFromKitchen.fulfilled, (state, action) => {
        state.removeCourierFromKitchenStatus = 'fulfilled';
        const { kitchenId, kitchenCourierAssignmentId } = action.payload;
        state.kitchens = state.kitchens.map(kitchen => {
          if (kitchen.kitchenId === kitchenId) {
            const removedCourierId = kitchen.courierAssignment.find(courier => courier.assignmentId === kitchenCourierAssignmentId);
            if (removedCourierId) {
              kitchen.courierAssignment = kitchen.courierAssignment.filter(courier => courier.assignmentId !== kitchenCourierAssignmentId);
            }
          }
          return kitchen;
        });
      })
      .addCase(removeCourierFromKitchen.rejected, (state) => { state.removeCourierFromKitchenStatus = 'rejected'; })

      // getDetailKitchen
      .addCase(getDetailKitchen.pending, (state) => { state.getDetailKitchenStatus = 'pending'; })
      .addCase(getDetailKitchen.fulfilled, (state, action) => { state.getDetailKitchenStatus = 'fulfilled'; state.detailKitchen = action.payload; })
      .addCase(getDetailKitchen.rejected, (state) => { state.getDetailKitchenStatus = 'rejected'; })

      // getCourierDetails
      .addCase(getCourierDetails.pending, (state) => { state.getCourierDetailsStatus = 'pending'; })
      .addCase(getCourierDetails.fulfilled, (state, action) => { state.getCourierDetailsStatus = 'fulfilled'; state.courierDetails = action.payload; })
      .addCase(getCourierDetails.rejected, (state) => { state.getCourierDetailsStatus = 'rejected'; })

      // getCouriersTrack
      .addCase(getCouriersTrack.pending, (state) => { state.getCouriersTrackStatus = 'pending'; })
      .addCase(getCouriersTrack.fulfilled, (state, action) => { state.getCouriersTrackStatus = 'fulfilled'; state.couriersTrack = action.payload; })
      .addCase(getCouriersTrack.rejected, (state) => { state.getCouriersTrackStatus = 'rejected'; })

      // changeCourierKMpassed
      .addCase(changeCourierKMpassed.pending, (state) => { state.changeCourierKMpassedStatus = 'pending'; })
      .addCase(changeCourierKMpassed.fulfilled, (state, action) => {
        state.changeCourierKMpassedStatus = 'fulfilled';
        const { courierId, km } = action.payload;
        state.couriers = state.couriers.map(courier =>
          courier.courierId === courierId ? { ...courier, kilometersPassedAdmin: km } : courier
        );
      })
      .addCase(changeCourierKMpassed.rejected, (state) => { state.changeCourierKMpassedStatus = 'rejected'; })

      // getDetailAddress
      .addCase(getDetailAddress.pending, (state) => { state.getDetailAddressStatus = 'pending'; })
      .addCase(getDetailAddress.fulfilled, (state, action) => {
        state.getDetailAddressStatus = 'fulfilled';
        state.detailAddress = action.payload;
      })
      .addCase(getDetailAddress.rejected, (state) => { state.getDetailAddressStatus = 'rejected'; })

      // addLocationPhoto
      .addCase(addLocationPhoto.pending, (state) => { state.addLocationPhotoStatus = 'pending'; })
      .addCase(addLocationPhoto.fulfilled, (state) => {
        state.addLocationPhotoStatus = 'fulfilled';
        state.locations = state.locations.map(location => location);
      })
      .addCase(addLocationPhoto.rejected, (state) => { state.addLocationPhotoStatus = 'rejected'; })

      // removeLocationPhoto
      .addCase(removeLocationPhoto.pending, (state) => { state.removeLocationPhotoStatus = 'pending'; })
      .addCase(removeLocationPhoto.fulfilled, (state, action) => {
        state.removeLocationPhotoStatus = 'fulfilled';
        const { fileStorageId } = action.payload;
        if (state.detailLocation && state.detailLocation.photosLocation) {
          state.detailLocation = {
            ...state.detailLocation,
            photosLocation: state.detailLocation.photosLocation.filter(photo => photo.fileStorageId !== fileStorageId)
          }
        }
      })
      .addCase(removeLocationPhoto.rejected, (state) => { state.removeLocationPhotoStatus = 'rejected'; })

      // addKitchenPhoto
      .addCase(addKitchenPhoto.pending, (state) => { state.addKitchenPhotoStatus = 'pending'; })
      .addCase(addKitchenPhoto.fulfilled, (state) => {
        state.addKitchenPhotoStatus = 'fulfilled';
        state.kitchens = state.kitchens.map(kitchen => kitchen);
      })
      .addCase(addKitchenPhoto.rejected, (state) => { state.addKitchenPhotoStatus = 'rejected'; })
      
      // removeKitchenPhoto
      .addCase(removeKitchenPhoto.pending, (state) => { state.removeKitchenPhotoStatus = 'pending'; })
      .addCase(removeKitchenPhoto.fulfilled, (state, action) => {
        state.removeKitchenPhotoStatus = 'fulfilled';
        const { fileStorageId } = action.payload;
        if (state.detailKitchen && state.detailKitchen.photosKitchen) {
          state.detailKitchen = {
            ...state.detailKitchen,
            photosKitchen: state.detailKitchen.photosKitchen.filter(photo => photo.fileStorageId !== fileStorageId)
          }
        }
      })
      .addCase(removeKitchenPhoto.rejected, (state) => { state.removeKitchenPhotoStatus = 'rejected'; })

      // PURGE
      .addCase(PURGE, () => initialState);
  },
  reducers: {
    //Form Filters
    updateFormFilterData: (state, action) => {
      const { ...rest } = action.payload;

      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...rest,
        },
      };
    },

    //Visibility
    updateMapDataVisibility: (state, action) => {
      const { ...rest } = action.payload;

      // Новое состояние
      const newState = {
        ...state,
        mapDataVisibility: {
          ...state.mapDataVisibility,
          ...rest,
        },
      };
      
      // Сохраняем в localStorage
      localStorage.setItem('mapDataVisibility', JSON.stringify(newState.mapDataVisibility));
      
      return newState;
    },

    //Search
    clearOrdersSearch: (state) => {
      state.searchOrdersQuery = '';
      state.foundOrders = [];
      state.deepFoundOrder = null;
    },

    //Location filters
    updateLocationFilters: (state, action) => {
      const { ...rest } = action.payload || {};
      state.locationFilters = {
        ...state.locationFilters,
        ...rest,
      };
    },
    resetLocationFilters: (state) => {
      state.locationFilters = {
        assigned: false,
        notAssigned: false,
        firstTimers: false,
      };
    },

    //Modes
    setMapMode: (state, action) => { state.mapMode = action.payload; if (action.payload === 'defaultMode') { state.currentCourierId = null; state.courierDetails = null; } },
    setRefresh: (state, action) => { state.refresh = action.payload; },
    setAutoRefresh: (state, action) => { state.autoRefresh = action.payload; },
    setSoundEnabled: (state, action) => { state.isSoundEnabled = action.payload; },
    resetSoundFlag: (state) => { state.shouldPlaySound = false; },

    clearData: (state) => {
      state.locationsShow = false;
      state.locations = [];
      state.currentLocationId = null;
      state.kitchensShow = false;
      state.kitchens = [];
      state.currentKitchenId = null;
      state.couriersShow = false;
      state.couriers = [];
      state.currentCourierId = null;
      state.addressesShow = false;
      state.addresses = [];
      state.currentAddressId = null;
      state.searchOrdersQuery = '';
      state.foundOrders = [];
      state.courierDetails = null;
      state.visibleCouriersTrack = [];
      state.mapMode = 'defaultMode';
    },

    //Locations
    setLocationsShow: (state, action) => {
      state.locationsShow = action.payload;
      state.kitchensShow = false;
      state.currentKitchenId = null;
      if (!action.payload) {
        state.searchOrdersQuery = '';
        state.foundOrders = [];
        state.mapMode = 'defaultMode';
        state.currentLocationId = null; // Сброс текущей локации при закрытии
        state.currentAddressId = null; // Сброс текущего адреса при закрытии
        state.currentCourierId = null; // Сброс текущего курьера при закрытии
      }
    },
    setCurrentLocationId: (state, action) => { state.currentLocationId = action.payload; },
    setDetailLocation: (state, action) => { state.detailLocation = action.payload; },
    clearGeocodeAddress: (state) => { state.geocodeAddress = null; },

    //Addresses
    setAddressesShow: (state, action) => {
      state.addressesShow = action.payload;
      if (!action.payload) {
        state.currentAddressId = null; // Сброс текущего адреса при закрытии
      }
    },
    setCurrentAddressId: (state, action) => { state.currentAddressId = action.payload; },

    //Kitchens
    setKitchensShow: (state, action) => {
      state.kitchensShow = action.payload;
      state.locationsShow = false;
      state.searchOrdersQuery = '';
      state.foundOrders = [];
      state.currentLocationId = null;
      if (!action.payload) {
        state.mapMode = 'defaultMode';
        state.currentKitchenId = null; // Сброс текущей кухни при закрытии
      }
    },
    setCurrentKitchenId: (state, action) => { state.currentKitchenId = action.payload; },
    setDetailKitchen: (state, action) => { state.detailKitchen = action.payload; },

    //Couriers
    setCouriersShow: (state, action) => {
      state.couriersShow = action.payload;
      state.mapMode = 'defaultMode';
      if (!action.payload) {
        state.currentCourierId = null; // Сброс текущего курьера при закрытии
      }
    },
    setCurrentCourierId: (state, action) => {
      state.currentCourierId = action.payload;
      if (!action.payload) {
        state.courierDetails = null; // Сброс деталей курьера при закрытии
      } 
    },
    switchVisibleCouriersTrack: (state, action) => {
      const courierId = action.payload;
      const visible = !state.visibleCouriersTrack.includes(courierId);
      if (visible) {
        state.visibleCouriersTrack.push(courierId);
      } else {
        state.visibleCouriersTrack = state.visibleCouriersTrack.filter(id => id !== courierId);
      }
    },
    
    //Polygons
    setPolygons: (state, action) => { state.polygons = action.payload; },
  },
});

export const {
  updateFormFilterData,
  updateMapDataVisibility,
  clearOrdersSearch,
  updateLocationFilters,
  resetLocationFilters,
  setMapMode,
  setRefresh,
  setAutoRefresh,
  setSoundEnabled,
  resetSoundFlag,
  clearData,
  setLocationsShow,
  setCurrentLocationId,
  setDetailLocation,
  clearGeocodeAddress,
  setAddressesShow,
  setCurrentAddressId,
  setKitchensShow,
  setCurrentKitchenId,
  setDetailKitchen,
  setCouriersShow,
  setCurrentCourierId,
  switchVisibleCouriersTrack,
  setPolygons,
} = deliveryMapSlice.actions;

export default deliveryMapSlice.reducer;
